module.exports = __webpack_public_path__ + "img/share_bubble@3x.2165e897.png";